import React from 'react';
import AdminLayout from '../../../../Components/CommonComponents/Layout/adminLayout';
import AdsFormContainer from '../../../../Containers/AdminContainer/Ads/AdsForm';
const AdsFormScreen = () => {
  return <AdsFormContainer />;
};

export default AdsFormScreen;
